// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FiQ4","buttons":"styles_buttons__X0vTj"};